// PC版とSP版の表示切り替えを判定するメディアクエリ
const pcMediaQuery = window.matchMedia('(orientation: landscape) and (max-width: 767px), (min-width: 768px)');

// 現在のモードを保存（PC/SP切り替え検知用）
let currentMode = pcMediaQuery.matches ? 'pc' : 'sp';

// 全てのSwiperインスタンスを保存
let allSwiperInstances = [];

// Swiper用HTMLの初期状態を保存する変数
let initialSwipersHTML = '';

// .fac-about-links要素の参照
const aboutLinksRoot = document.querySelector('.fac-about-links');
if (aboutLinksRoot) {
  // 初回ロード時にSwiper用HTML部分だけ保存
  const swipers = aboutLinksRoot.querySelectorAll('.fac-about-links__swiper');
  let html = '';
  swipers.forEach((swiper) => {
    html += swiper.outerHTML;
  });
  initialSwipersHTML = html;
}

function initSwiper() {
  if (pcMediaQuery.matches) {
    // PC表示: 縦スクロールSwiper（両方とも上方向）
    const vertical1Elements = document.querySelectorAll('.fac-about-links__swiper--vertical-1');

    vertical1Elements.forEach((element, index) => {
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'none') {
        return;
      }

      const rect = element.getBoundingClientRect();

      const slides = element.querySelectorAll('.swiper-slide');

      if (slides.length >= 1) {
      }

      if (slides.length < 2) {
        return;
      }

      const swiper = new Swiper(element, {
        direction: 'vertical',
        loop: true,
        speed: 11000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          waitForTransition: true,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        loopAdditionalSlides: 2,
        observer: true,
        observeParents: true,
      });
      swiper.update();
      // 強制的に停止してから再開
      swiper.autoplay.stop();
      swiper.autoplay.start();
      allSwiperInstances.push(swiper);
    });

    // 右側のスライダーは逆方向(下方向)に流れる
    const vertical2Elements = document.querySelectorAll('.fac-about-links__swiper--vertical-2');

    vertical2Elements.forEach((element, index) => {
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'none') {
        return;
      }

      const rect = element.getBoundingClientRect();

      const slides = element.querySelectorAll('.swiper-slide');

      if (slides.length >= 1) {
      }

      if (slides.length < 2) {
        return;
      }

      const swiper = new Swiper(element, {
        direction: 'vertical',
        loop: true,
        speed: 11000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          reverseDirection: true,
          pauseOnMouseEnter: false,
          waitForTransition: true,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        loopAdditionalSlides: 2,
        observer: true,
        observeParents: true,
      });
      swiper.update();
      // 強制的に停止してから再開
      swiper.autoplay.stop();
      swiper.autoplay.start();
      allSwiperInstances.push(swiper);
    });
  } else {
    // SP表示: 横スクロールSwiper（両方とも左方向）
    const horizontal1Elements = document.querySelectorAll('.fac-about-links__swiper--horizontal-1');

    horizontal1Elements.forEach((element, index) => {
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'none') {
        return;
      }

      const rect = element.getBoundingClientRect();

      const slides = element.querySelectorAll('.swiper-slide');

      if (slides.length >= 1) {
      }

      if (slides.length < 2) {
        return;
      }

      const swiper = new Swiper(element, {
        direction: 'horizontal',
        loop: true,
        speed: 11000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          waitForTransition: true,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        loopAdditionalSlides: 2,
        observer: true,
        observeParents: true,
      });
      swiper.update();
      // 強制的に停止してから再開
      swiper.autoplay.stop();
      swiper.autoplay.start();
      allSwiperInstances.push(swiper);
    });

    // 下側のスライダーは逆方向(右方向)に流れる
    const horizontal2Elements = document.querySelectorAll('.fac-about-links__swiper--horizontal-2');

    horizontal2Elements.forEach((element, index) => {
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'none') {
        return;
      }

      const rect = element.getBoundingClientRect();

      const slides = element.querySelectorAll('.swiper-slide');

      if (slides.length >= 1) {
      }

      if (slides.length < 2) {
        return;
      }

      const swiper = new Swiper(element, {
        direction: 'horizontal',
        loop: true,
        speed: 11000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          reverseDirection: true,
          pauseOnMouseEnter: false,
          waitForTransition: true,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        initialSlide: 2,
        loopAdditionalSlides: 2,
        observer: true,
        observeParents: true,
      });
      swiper.update();
      // 強制的に停止してから再開
      swiper.autoplay.stop();
      swiper.autoplay.start();
      allSwiperInstances.push(swiper);
    });
  }
  // 初期化直後のDOM要素数とインスタンス数を出力
}

// Swiperを全て破棄する関数
function destroyAllSwipers() {
  allSwiperInstances.forEach((swiper) => {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  });
  allSwiperInstances = [];
  // Swiper用DOM要素も全て削除
  const swipersInDOM = document.querySelectorAll('.fac-about-links__swiper');
  swipersInDOM.forEach((el) => {
    el.remove();
  });
  // Swiper用HTMLを初期状態に復元
  if (aboutLinksRoot && initialSwipersHTML) {
    // 既存のcarousel-container内に再挿入
    const container = aboutLinksRoot.querySelector('.fac-about-links__carousel-container');
    if (container) {
      container.insertAdjacentHTML('beforeend', initialSwipersHTML);
    }
  }
}

// メディアクエリの変更を監視
pcMediaQuery.addEventListener('change', (e) => {
  const newMode = e.matches ? 'pc' : 'sp';
  currentMode = newMode;

  // 既存のSwiperを破棄して再初期化
  destroyAllSwipers();
  initSwiper();
});

// Intersection Observerで画面内に入ったときにautoplayを再開する関数
function setupAutoplayIntersectionObserver() {
  const targetElement = document.querySelector('.fac-about-links');
  if (targetElement) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          allSwiperInstances.forEach((swiper) => {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.stop();
              swiper.autoplay.start();
            }
          });
        }
      });
    });
    observer.observe(targetElement);
  }
}

// DOMが完全にロードされてから初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupAutoplayIntersectionObserver();
    initSwiper();
  });
} else {
  setupAutoplayIntersectionObserver();
  initSwiper();
}
